/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Card,
  Typography,
} from '@mui/material';
import ThaiQrPayment from '../../assets/images/CreditCardImage1.png';
import HeadQrPayment from '../../assets/images/thai_qr_payment1.png';
import SecondQrPayment from '../../assets/images/CreditCardImage1.png';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const QRCredit = ({
  open,
  onClose,
  qrCodeImage,
  orderId,
  paymentRefId,
  handleRefresh,
  language,
  companyName,
}) => {
  const [countdown, setCountdown] = useState(30 * 60); // 30 นาที
  const [isCountingDown, setIsCountingDown] = useState(false);

  useEffect(() => {
    let timer;
    if (isCountingDown && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      setIsCountingDown(false);
      setCountdown(30 * 60); // รีเซ็ตกลับไป 30 นาที
    }
    return () => clearTimeout(timer);
  }, [isCountingDown, countdown]);

  useEffect(() => {
    if (open) {
      setIsCountingDown(true);
      setCountdown(30 * 60);
    }
  }, [open]);

  const formatCountdown = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const handleAutorenewClick = () => {
    if (!isCountingDown) {
      handleRefresh();
      setIsCountingDown(true);
      setCountdown(30 * 60);
    }
  };

  const handleSaveClick = () => {
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${qrCodeImage}`;
    link.download = 'QRCode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isLineBrowser = navigator.userAgent.toLowerCase().includes('line');
  const isFacebookBrowser = navigator.userAgent.toLowerCase().includes('fb');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '500px',
        },
      }}
    >
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <IconButton onClick={onClose} sx={{ color: '#8B8888' }}>
          <CloseIcon />
        </IconButton>
      </DialogActions>

      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginLeft: '20px',
            marginTop: '-25px',
          }}
        >
          {language === 'TH' ? 'ชำระผ่าน QR Credit' : 'Pay via QR Code'}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px',
            zIndex: 3,
          }}
        >
          <img
            src={HeadQrPayment}
            alt="Thai QR Payment"
            style={{
              width: '100%',
              maxWidth: '400px',
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
            }}
          />
          <img
            src={SecondQrPayment}
            alt="Credit Card"
            style={{ width: '35%', maxWidth: '400px', marginTop: '10px' }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            height: '100%',
            marginLeft: '30px',
          }}
        >
          <img
            src={`data:image/png;base64,${qrCodeImage}`}
            alt="QR Code"
            style={{
              width: '200px',
              height: '200px',
              objectFit: 'cover',
            }}
          />
          <AutorenewIcon
            sx={{
              fontSize: 20,
              color: isCountingDown ? '#C1C1C1' : '#000',
              cursor: isCountingDown ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignSelf: 'self-end',
              marginLeft: '10px',
            }}
            onClick={handleAutorenewClick}
          />
        </Box>
        {!isLineBrowser && !isFacebookBrowser && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '2px solid transparent',
            }}
          >
            <Button
              onClick={handleSaveClick}
              sx={{
                color: '#ffffff',
                backgroundColor: '#007bff',
                borderColor: '#007bff',
                '&:hover': {
                  backgroundColor: '#0056b3',
                  borderColor: '#0056b3',
                },
              }}
              size="small"
              startIcon={<SaveIcon />}
            >
              {language === 'TH' ? 'บันทึก' : 'Save'}
            </Button>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'left',
            fontSize: '18px',
            fontWeight: 'bold',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          {companyName}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'left',
            fontSize: '16px',
            marginLeft: '20px',
          }}
        >
          REF : {orderId}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'left',
            fontSize: '16px',
            marginLeft: '20px',
          }}
        >
          {paymentRefId}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Card
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              fontSize: '16px',
              marginTop: '20px',
              marginRight: '20px',
              padding: '16px',
              boxShadow: 1,
              width: '100%',
              backgroundColor: '#F5F5F5',
            }}
          >
            <Typography sx={{ fontWeight: 'bold', fontSize: '17px' }}>
              {language === 'TH' ? 'วิธีการชำระเงิน' : 'Payment Instructions'}
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>
              {language === 'TH'
                ? '1. คลิกปุ่ม บันทึก หรือ แคปหน้าจอ'
                : '1. Click the Save button or take a screenshot'}
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>
              {language === 'TH'
                ? '2. เปิดแอปพลิเคชั่นธนาคารบนอุปกรณ์ของท่าน'
                : '2. Open your banking app on your device'}
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>
              {language === 'TH'
                ? '3. เลือกรูปภาพที่ท่านบันทึก หรือ แคปไว้ และทำการชำระเงิน โดยกรุณาเช็คชื่อบัญชีผู้รับคือ "ไอเน็ต อีเพย์เม้นท์"'
                : '3. Select the saved image or screenshot and proceed with payment. Please check the recipient account name: "INET ePayment"'}
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>
              {language === 'TH'
                ? '4. QR สามารถสแกนได้ 1 ครั้งต่อ 1 การชำระเงินเท่านั้น หากต้องการสแกนใหม่ โปรดกดรีเฟรชเพื่อขอ QR ใหม่อีกครั้ง'
                : '4. The QR code can be scanned once per payment. To scan again, please refresh to get a new QR code'}
            </Typography>
          </Card>
        </Box>
        {isCountingDown && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            <Typography
              sx={{ fontSize: '14px', color: '#FFFFF', fontWeight: 'bold' }}
            >
              {language === 'TH'
                ? `กรุณารอ ${formatCountdown(
                    countdown,
                  )} นาที ก่อนรีเฟรช QR Code ใหม่`
                : `Please wait ${formatCountdown(
                    countdown,
                  )} minutes before refreshing the QR Code`}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default QRCredit;
